import _ from 'lodash';
import url from 'url';

export function redirectToPayment({
  contractNumbers,
  amounts,
  sum,
  comments,
  nsfComment,
  customComment,
  autoLogin = true,
  forwardTokenParams,
}) {
  window.location.href = url.format({
    protocol: 'https',
    host: process.env.REACT_APP_PRCO_ACH_PAYMENTS_HOST || 'payprco.com',
    query: {
      autoLogin,
      payment: sum,
      contractNumbers: _.join(contractNumbers, ','),
      amounts: _.join(amounts, ','),
      comments,
      nsfComment,
      customComment,
      ...forwardTokenParams,
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/redirect.js